<script setup lang="ts">
const props = defineProps<{
  message?: string;
}>();

const fallbackMessage = 'Please sign in to access this section.';
</script>

<template>
  <section class="protected-block-message" role="status">
    <p>{{ props.message || fallbackMessage }}</p>
  </section>
</template>

<style scoped>
.protected-block-message {
  margin: 1.5rem 0;
  padding: 1rem;
  border: 1px solid var(--color-border, #ccc);
  border-radius: 4px;
  background-color: var(--color-surface-muted, #f7f7f7);
}
</style>
